<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户昵称" prop="nickname" >
        <a-input disabled v-model="form.nickname" placeholder="请输入用户昵称" />
      </a-form-model-item>
      <a-form-model-item label="用户电话" prop="mobile" >
        <a-input disabled v-model="form.mobile" placeholder="请输入用户电话" />
      </a-form-model-item>
      <a-form-model-item label="提现金额" prop="money" >
        <a-input disabled v-model="form.money" placeholder="请输入提现金额" />
      </a-form-model-item>
      <a-form-model-item label="提现类型" prop="type" >
        <a-select disabled v-model="form.type" allow-clear>
          <a-select-option value="WX_APP">微信</a-select-option>
          <a-select-option value="ALIPAY_APP">支付宝</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="提现渠道" prop="channelType" >
        <a-select disabled v-model="form.channelType" allow-clear>
          <a-select-option value="1">用户端</a-select-option>
          <a-select-option value="2">商家端</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="创建时间" prop="createTime" >
        <a-input disabled v-model="form.createTime" placeholder="" />
      </a-form-model-item>
      <a-form-model-item label="审核状态" prop="status" >
        <a-select v-model="form.status" allow-clear>
          <a-select-option value="10">待审核</a-select-option>
          <a-select-option value="20">审核通过</a-select-option>
          <a-select-option value="30">审核拒绝</a-select-option>
          <a-select-option value="40">到账异常</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input disabled v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWithdrawalRecord, addWithdrawalRecord, updateWithdrawalRecord } from '@/api/withdrawalRecord/withdrawalRecord'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,
        nickname: null,
        mobile: null,
        channelType: null,
        status: null,
        type: null,
        money: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id user_user.id不能为空', trigger: 'blur' }
        ],

        money: [
          { required: true, message: '提现金额不能为空', trigger: 'blur' }
        ],

        isDeleted: [
          { required: true, message: '逻辑删除标记，1：删除，0：未删除，默认0不能为空', trigger: 'blur' }
        ],

        version: [
          { required: true, message: '乐观锁不能为空', trigger: 'blur' }
        ]

      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,

        userId: null,
        nickname: null,
        mobile: null,
        channelType: null,
        status: null,
        type: null,
        money: null,

        createTime: null,

        remark: null

      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWithdrawalRecord(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateWithdrawalRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addWithdrawalRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
